export const apiUrl = process.env.NODE_ENV === 'production' ? 'https://hr.ujoyer.com/api/' : '/api/'
export const qiniu = 'http://api.qiniu.com/qiniu/'
export const upload = 'http://upload.qiniup.com/upload/'
export const imgUrl = 'https://dn-simplecloud.shiyanlou.com/'
